/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { DashboardLayout } from '../components/Dashboard';
import { ValidAccessToken, pagesRouter, stringMin } from '../core/function/function-generic';
import { useLocation } from 'react-router-dom';
import SectionTap from '../components/SectionTap';
import { requestHttp } from '../api/services-third-parties';
import { useSelector } from 'react-redux';

type SettingsProps = {
    onSearchGen: string;
};

const Settings = ({ onSearchGen }: SettingsProps) => {
    document.body.style.background = "#FFF";
    const location = useLocation();
    const state = useSelector((state: any) => state.business);
    const [optionActive, setOptionActive] = useState<string>('Asset Support')
    const [dataCrypto, setdataCrypto] = useState<any[]>([])
    const [datatap, setdatatap] = useState<any[]>();

    useEffect(() => {
        ValidAccessToken()
        setdatatap([
            { name: 'General', class: 'home-title-tap fontPageTitle text-center cursor-pointer' },
            { name: 'Asset Support', class: 'home-title-tap fontPageTitle text-center cursor-pointer' },
        ])
        getCryptoBusissneId(state.id);
    }, []);

    const onsearchFilter = (nameTap: string) => {
        setOptionActive(nameTap)
    };

    const FormSettingGeneral = () => {
        return (
            <form>
                <div className='w-[65.666rem]'>
                    <div className="mb-6">
                        <label className="block mb-2 text-[14px] font-[600] leading-[19px]">Account name</label>
                        <input type="text" id="text" className="border rounded-lg block w-full p-2.5" placeholder="" />
                    </div>
                    <div className="mb-6">
                        <label className="block mb-2 text-[14px] font-[600] leading-[19px]">Domain</label>
                        <input type="password" id="password" className="border rounded-lg block w-full p-2.5" placeholder="•••••••••" />
                    </div>
                    <div>
                        <p className='text-[16px] text-justify leading-[19.5px] font-[400] pb-[30px]'>
                            Introduce the list of domains (including https://) in which you will embed
                            the Alfred Pay widget using an iframe (Comma separated list e.g https://example.com, https://website.com)
                        </p>
                    </div>
                    <div>
                        <button
                            className="fontPageTitle  px-6 py-2 btn-active rounded-[24px] 
                            mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                        >
                            <div className="font-size-12">Report transaction</div>
                        </button>
                    </div>
                </div>
            </form>
        )
    }

    const FormSettingAssetSupport = () => {
        return (
            <div className='w-full ml-8'>
                <div className='text-[#111827] text-[1rem] font-semibold font-[Montserrat] leading-[19px] mb-4'>
                    Cryptocurrencies
                    <p className='text-[14px] font-normal font-[Montserrat] leading-[19px]'>
                        Find a list below of the currencies  available:
                    </p>

                </div>
                <div className=''>
                    <p className='text-black text-[1rem] font-medium font-[Inter] leading-6 mt-6 mb-2'>
                        Selected Currencies
                    </p>
                    {
                        dataCrypto.map((res: any, index: number) => (
                            <div className="flex items-center" key={index}>
                                {/*
                                    <input
                                    type="checkbox"
                                    value=""
                                    checked={true}
                                    onChange={() => handleCryptoSelectionChange(index)}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 
                                    dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                /> */}
                                <li className="ml-4 text-black text-[1rem] font-medium font-[Inter] leading-6">
                                    <span>{res.coin}</span> - <span>{stringMin(res.network)}</span>
                                </li>
                            </div>
                        ))
                    }
                    <p className='text-[#111827] text-[0.875rem] font-normal font-[Montserrat] leading-[19px] mt-6'>
                        If a new currency asset is needed feel free to reach out to our team at
                        <a
                            href='mailto:hola@alfredpay.io'
                            className='text-[#005FF9] text-[0.875rem] font-semibold font-[Montserrat] leading-[19px] underline ml-2'
                        >
                            hola@alfredpay.io
                        </a>
                    </p>
                </div>
            </div>
        )
    }

    const getCryptoBusissneId = async (id: number) => {
        try {

            const response = await requestHttp(
                `/withdrawals/crypto-currencies/${id}`,
                'GET',
            )

            responseRequest(response);

        } catch (err) {
            console.error(err);
        }
    }

    const responseRequest = (response: any) => {
        if ([400].includes(response.data.statusCode)) {

        }

        if ([202].includes(response.data.statusCode)) {
            const res = response.data['data']['data'];

            setdataCrypto(dataMap(res))

        }
    }

    const dataMap = (row: any) => {
        return row.map((item: any) => {
            return {
                network: item.network,
                coin: item.coin
            }
        })
    }

    return (
        <DashboardLayout pageTitle={pagesRouter(location.pathname)} onSearchGen={onSearchGen}>
            <SectionTap onsearchFilter={onsearchFilter} datatap={datatap} optionActive={optionActive} />
            {
                optionActive.includes('General') ?
                    (
                        <FormSettingGeneral />
                    ) :
                    (
                        <FormSettingAssetSupport />
                    )
            }
        </DashboardLayout>
    );
};

export default Settings;